import Font from '../../font/Font'

export function formatFontStyle(data) {
  const font = new Font()

  if (data)
    font.fromData(data)

  return font
}